<template>
  <div id="app" ref="app">
    <Header v-if="$route.meta && !$route.meta.boxHeaderHidden"></Header>
    <div style="height: 100%;background-color: white;overflow:hidden" v-if="$route.meta && $route.meta.view">
      <!-- 面包屑 -->
      <router-view v-if="!$route.meta || !$route.meta.boxHidden"/>
      <router-view v-if="$route.meta && $route.meta.boxHidden" />
    </div>
    <div v-else class="self_adaption_mainWid1200">
      <!-- 面包屑 -->
      <Crumbs></Crumbs>
      <router-view v-if="!$route.meta || !$route.meta.boxHidden"></router-view>
      <router-view v-if="$route.meta && $route.meta.boxHidden" />
    </div>
    <object class="obj-footer" data="/web/Common/snippet/footer.html?json=%7B%22contacts%22:%5B%7B%22name%22:%22%E4%B8%9A%E5%8A%A1%E5%92%A8%E8%AF%A2%22,%20%22value%22:%20%5B%22010-55579441%22%5D%7D,%7B%22name%22:%22%E6%8A%80%E6%9C%AF%E6%94%AF%E6%8C%81%22,%20%22value%22:%20%5B%22010-67800498%22%5D%7D%5D%7D"></object>
  </div>
</template>

<script>
import Header from '@/components/Header.vue';
import Crumbs from '@/components/Crumbs.vue';
export default {
  name: 'App',
  components: {
    Header,
    Crumbs,
  }
};
</script>

<style>
* {
  margin: 0px;
  padding: 0px;
  list-style: none;
  text-decoration: none;
}

html,
body,
#app {
  width: 100%;
  /* height: 100%; */
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: #E9EEF3;
  margin: 0 auto;
}

.self_adaption {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.self_adaption_main {
  min-height: 637px;
  background: #E9EEF3;
}

.self_adaption_mainWid1200 {
  width: 1200px;
  height: 100%;
  margin: 0 auto;
}

.Form {
  display: flex;
  flex-wrap: wrap;
}

.el-button {
  height: 40px;
}

.FormBtn {
  float: right;
  margin-left: 25px;
  margin-right: 30px;
  margin-bottom: 20px;
}

.centerBtn {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.flexSpace {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.el-tabs {
  width: 50%;
}

.el-tabs__item {
  width: 150px;
  height: 48px !important;
  line-height: 44px !important;
  font-size: 16px !important;
  color: #999999 !important;
  font-weight: bold !important;
  text-align: center;
  cursor: pointer;
}

.el-tabs__nav .is-active {
  color: #f56c6c !important;
}

.el-tabs__active-bar {
  height: 4px !important;
  background: #f56c6c !important;
}

.FormFlex {
  display: flex;
  flex-wrap: wrap;
}

.width15 {
  width: 15%;
}

.width20 {
  width: 20%;
}

.width22 {
  width: 22%;
}

.width23 {
  width: 23%;
}

.width24 {
  width: 24%;
}

.width25 {
  width: 25%;
}

.width27 {
  width: 27%;
}

.width33 {
  width: 33%;
}

.width35 {
  width: 35%;
}

.width48 {
  width: 48%;
}

.width66 {
  width: 66%;
}

.width96 {
  width: 96%;
}

.width99 {
  width: 99%;
}

.width100 {
  width: 100%;
}

.FormFlex .el-select {
  width: 100%;
}

.FormFlex .el-date-editor.el-input {
  width: 100%;
}

.marginlr100 {
  margin: 0px 80px;
  width: 80%;
}

.ColorDan {
  color: #a30014 !important;
}

.Color {
  color: #bd1a2d !important;
}

.cursor {
  cursor: pointer;
}

.font16 {
  font-size: 16px;
}

.bold {
  font-weight: bold;
}

.TitleCenter {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  margin-bottom: 10px;
}

.TitleCenter p {
  margin: 5px 0px;
  font-size: 18px;
  font-weight: 800;
}

.el-input__inner,
.el-textarea__inner,
.el-select__tags-text,
.el-radio__label {
  color: #606266 !important;
}

.el-radio__input.is-disabled .el-radio__inner,
.el-radio__input.is-disabled.is-checked .el-radio__inner {
  background-color: #f5f7fa !important;
  border-color: #606266 !important;
}

.el-radio__input.is-disabled.is-checked .el-radio__inner::after {
  background-color: #606266 !important;
}

.el-menu--horizontal>.el-menu-item.is-active {
  background: #ae1529 !important;
}

.el-menu--horizontal>.el-submenu.is-active .el-submenu__title {
  color: white !important;
  background: #ae1529 !important;
}

.el-tooltip__popper {
  font-size: 14px !important;
  max-width: 20% !important;
  line-height: 18px !important;
}

.el-tooltip__popper.is-dark {
  background-color: #E9EEF3 !important;
  color: black !important;
}

.uploaddemo {
  width: 336px !important;
}

.el-divider__text.is-left {
  background: #E9EEF3;
}

.submitDiv {
  margin: 30px auto;
  width: 175px;
  display: flex;
  justify-content: space-between;
}

.el-pagination {
  margin-right: 50px;
}
</style>
